import React, { memo, useState, useEffect } from 'react';
import { Image } from 'react-native';
import { useTheme } from '@redlink/assets/styles';

export const AutoHeightImage = memo(({ style, uri, ...rest }) => {
  const { contentWidth } = useTheme();
  const [height, setHeight] = useState(contentWidth);

  useEffect(() => {
    Image.getSize(
      uri,
      (w, h) => setHeight((h * contentWidth) / w),
      (error) => {}
    );
  }, []);

  return (
    <Image
      style={[style, { width: contentWidth, height }]}
      {...rest}
      source={{ uri }}
    />
  );
});
